class AboutVideo extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    var self = this;
    var btn = this.querySelector('[data-play-btn]');
    var overlay = this.querySelector('[data-overlay]');
    var controls = this.querySelector('[data-controls]');
    var videos = [...this.querySelectorAll('[data-video]')];
    if (!btn || !videos.length) return;

    function getActiveVideo() {
      if (videos.length === 1) return videos[0];
      return videos.find(function (v) { return v.offsetParent !== null; }) || videos[0];
    }

    function loadVideo(video) {
      if (!video || !video.dataset.src) return;
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      video.load();
    }

    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) {
        videos.forEach(loadVideo);
        obs.disconnect();
      }
    }, { rootMargin: '200% 0px', threshold: 0 }).observe(self);

    btn.addEventListener('click', function () {
      var video = getActiveVideo();
      loadVideo(video);
      video.setAttribute('controls', '');
      video.play();
      overlay.style.pointerEvents = 'none';
      controls.style.pointerEvents = 'none';
      overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, fill: 'forwards' });
      controls.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, fill: 'forwards' });
    });

    videos.forEach(function (video) {
      video.addEventListener('ended', function () {
        video.removeAttribute('controls');
        overlay.style.pointerEvents = '';
        controls.style.pointerEvents = '';
        overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, fill: 'forwards' });
        controls.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 400, fill: 'forwards' });
      });
    });
  }
}

customElements.define('about-video', AboutVideo);
